import template from './adpListItem.html';
import controller from './adpListItem.controller';
import './adpListItem.less';

let adpListItemComponent = {
  restrict: 'E',
  bindings: {
    title:'<',
    date:'<',
    hour: '<',
    count: '<',
    hasErrors: '<',
    id: '<',
  },
  template,
  controller
};

export default adpListItemComponent;



// WEBPACK FOOTER //
// ./src/app/components/adpListItem/adpListItem.component.js